<template>
  <div v-if="noteList.length">
    <note-item :note="noteList.at(-1)" hideDelete>
      <template #showAllNotes>
        <v-btn
          size="small"
          style="padding: 0 !important"
          variant="text"
          @click="openNotesDialog">
          Показати всі...
        </v-btn>
      </template>
    </note-item>
  </div>
  <div v-else>
    <div v-if="!disabled" class="wrapper" @click="openNotesDialog">
      <v-icon color="#49A2F4" icon="mdi-plus" />
      <span class="label d-block">Додати</span>
    </div>
    <span v-if="disabled" class="label">Дія неможлива</span>
  </div>
</template>

<script>
import NoteItem from '@/dialog/components/notes/NoteItem.vue'
import { openDialog } from '@/dialog'
import { useNotes } from './index'

export default {
  components: { NoteItem },
  props: {
    disabled: { type: Boolean },
  },
  setup() {
    const { noteList, entityId, entityTypeId } = useNotes()

    const openNotesDialog = () => {
      openDialog({
        name: 'Notes',
        dialogData: {
          notes: noteList.value,
          entityId,
          entityTypeId,
          updateNotes: notes => (noteList.value = notes),
        },
        params: {
          hideActionButtons: true,
        },
      })
    }
    return { openNotesDialog, noteList }
  },
}
</script>

<style lang="scss" scoped>
.wrapper {
  border-radius: 4px;
  border: 1px dashed #e0e4e7;
  padding: 16px 8px;
  text-align: center;
  transition: 0.3s;

  &:hover {
    background: #eefafc;
  }

  .label {
    color: #1a1a1b;
    font-size: 14px;
    font-weight: 500;
    letter-spacing: normal;
    cursor: default;
  }
}
</style>
